module.exports = __webpack_public_path__ + "img/team_joachim_lovenskjold_persson.16787e1e.webp";